<span
  [ngClass]="{
    'bg-danger': !connected,
    'bg-success': connected,
    'bg-warning': connecting
  }"
  class="status-badge position-absolute top-0 start-100 translate-middle p-1 border border-dark rounded-circle"
></span>
